import { HelpHint } from "../misc/HelpHint";
import { ActivityAuthor } from "../activity/ActivityAuthor";
import { useState } from "react";
import { useGetList } from "ra-core";
import { Button } from "@/components/ui/button";
import type { Deal } from "../types";
import type { FinancePlan } from "./financeModel";
import { rubles } from "./expenseModel";
import {
  ADJUSTMENT_REASONS,
  BUDGET_ZONES,
  type BudgetAdjustment,
} from "./adjustmentModel";

export function ProjectAdjustments({
  project,
}: {
  project: Deal;
  plan?: FinancePlan;
}) {
  const [page, setPage] = useState(1);
  const list = useGetList<BudgetAdjustment>("project_budget_adjustments", {
    filter: { deal_id: project.id },
    sort: { field: "revision", order: "DESC" },
    pagination: { page, perPage: 10 },
  });
  return (
    <div className="space-y-3 border-t pt-4">
      <div className="flex items-center gap-1">
        <h4 className="font-medium">Журнал корректировок</h4>
        <HelpHint>
          Корректировки создаются при подтверждении неплановых расходов. Старые
          операции сохраняются в журнале.
        </HelpHint>
      </div>
      {list.error ? (
        <p role="alert">Не удалось загрузить журнал</p>
      ) : list.isPending ? (
        <p>Загрузка…</p>
      ) : !list.data?.length ? (
        <p className="text-sm">Корректировок пока нет.</p>
      ) : (
        list.data.map((a) => (
          <div key={a.id} className="border rounded-md p-3 text-sm space-y-1">
            <p className="font-medium">
              {a.reverses_id != null
                ? "Отмена #" + a.reverses_id
                : "Корректировка #" + a.id}{" "}
              · {rubles(a.amount)}
            </p>
            <p>
              {BUDGET_ZONES.find((z) => z.key === a.from_zone)?.label} →{" "}
              {BUDGET_ZONES.find((z) => z.key === a.to_zone)?.label}
            </p>
            <p>
              {ADJUSTMENT_REASONS.find((r) => r.value === a.reason)?.label}
              {a.sales_id != null
                ? " · Сотрудник #" + a.sales_id
                : a.company_id != null
                  ? " · Подрядчик #" + a.company_id
                  : ""}
            </p>
            <p className="whitespace-pre-line">{a.note}</p>
            <p className="text-xs text-muted-foreground">
              <ActivityAuthor id={a.created_by_sales_id} /> ·{" "}
              {new Date(a.created_at).toLocaleString("ru-RU", {
                timeZone: "Europe/Moscow",
              })}
            </p>
          </div>
        ))
      )}
      {((list.total ?? 0) > 10 || page > 1) && (
        <div className="flex gap-3 items-center">
          <Button
            variant="outline"
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
          >
            Назад
          </Button>
          <span>Страница {page}</span>
          <Button
            variant="outline"
            disabled={page * 10 >= (list.total ?? 0)}
            onClick={() => setPage((p) => p + 1)}
          >
            Далее
          </Button>
        </div>
      )}
    </div>
  );
}
